/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AmountUnit,
    AmountUnitFromJSON,
    AmountUnitFromJSONTyped,
    AmountUnitToJSON,
    DurationUnit,
    DurationUnitFromJSON,
    DurationUnitFromJSONTyped,
    DurationUnitToJSON,
    EmailTemplate,
    EmailTemplateFromJSON,
    EmailTemplateFromJSONTyped,
    EmailTemplateToJSON,
    RewardType,
    RewardTypeFromJSON,
    RewardTypeFromJSONTyped,
    RewardTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface RewardConfigResponse
 */
export interface RewardConfigResponse {
    /**
     * 
     * @type {string}
     * @memberof RewardConfigResponse
     */
    id: string;
    /**
     * 
     * @type {RewardType}
     * @memberof RewardConfigResponse
     */
    type: RewardType;
    /**
     * 
     * @type {string}
     * @memberof RewardConfigResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof RewardConfigResponse
     */
    description: string;
    /**
     * 
     * @type {boolean}
     * @memberof RewardConfigResponse
     */
    shouldEmailUser: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RewardConfigResponse
     */
    shouldEmailAdmin: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RewardConfigResponse
     */
    shouldSendNotificationWeb: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RewardConfigResponse
     */
    shouldSendNotificationDevourPlay: boolean;
    /**
     * 
     * @type {number}
     * @memberof RewardConfigResponse
     */
    amount?: number;
    /**
     * 
     * @type {AmountUnit}
     * @memberof RewardConfigResponse
     */
    amountUnit?: AmountUnit;
    /**
     * 
     * @type {number}
     * @memberof RewardConfigResponse
     */
    durationAmount?: number;
    /**
     * 
     * @type {DurationUnit}
     * @memberof RewardConfigResponse
     */
    durationUnit?: DurationUnit;
    /**
     * 
     * @type {string}
     * @memberof RewardConfigResponse
     */
    assetId?: string;
    /**
     * 
     * @type {string}
     * @memberof RewardConfigResponse
     */
    nftTrackerId?: string;
    /**
     * 
     * @type {string}
     * @memberof RewardConfigResponse
     */
    orderDiscountId?: string;
    /**
     * 
     * @type {string}
     * @memberof RewardConfigResponse
     */
    promoTokenId?: string;
    /**
     * 
     * @type {string}
     * @memberof RewardConfigResponse
     */
    questConfigId?: string;
    /**
     * 
     * @type {EmailTemplate}
     * @memberof RewardConfigResponse
     */
    emailTemplate?: EmailTemplate;
    /**
     * 
     * @type {string}
     * @memberof RewardConfigResponse
     */
    claimFormUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof RewardConfigResponse
     */
    maxClaimCount?: number;
    /**
     * 
     * @type {string}
     * @memberof RewardConfigResponse
     */
    disclaimer?: string;
}

export function RewardConfigResponseFromJSON(json: any): RewardConfigResponse {
    return RewardConfigResponseFromJSONTyped(json, false);
}

export function RewardConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RewardConfigResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': RewardTypeFromJSON(json['type']),
        'name': json['name'],
        'description': json['description'],
        'shouldEmailUser': json['shouldEmailUser'],
        'shouldEmailAdmin': json['shouldEmailAdmin'],
        'shouldSendNotificationWeb': json['shouldSendNotificationWeb'],
        'shouldSendNotificationDevourPlay': json['shouldSendNotificationDevourPlay'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'amountUnit': !exists(json, 'amountUnit') ? undefined : AmountUnitFromJSON(json['amountUnit']),
        'durationAmount': !exists(json, 'durationAmount') ? undefined : json['durationAmount'],
        'durationUnit': !exists(json, 'durationUnit') ? undefined : DurationUnitFromJSON(json['durationUnit']),
        'assetId': !exists(json, 'assetId') ? undefined : json['assetId'],
        'nftTrackerId': !exists(json, 'nftTrackerId') ? undefined : json['nftTrackerId'],
        'orderDiscountId': !exists(json, 'orderDiscountId') ? undefined : json['orderDiscountId'],
        'promoTokenId': !exists(json, 'promoTokenId') ? undefined : json['promoTokenId'],
        'questConfigId': !exists(json, 'questConfigId') ? undefined : json['questConfigId'],
        'emailTemplate': !exists(json, 'emailTemplate') ? undefined : EmailTemplateFromJSON(json['emailTemplate']),
        'claimFormUrl': !exists(json, 'claimFormUrl') ? undefined : json['claimFormUrl'],
        'maxClaimCount': !exists(json, 'maxClaimCount') ? undefined : json['maxClaimCount'],
        'disclaimer': !exists(json, 'disclaimer') ? undefined : json['disclaimer'],
    };
}

export function RewardConfigResponseToJSON(value?: RewardConfigResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': RewardTypeToJSON(value.type),
        'name': value.name,
        'description': value.description,
        'shouldEmailUser': value.shouldEmailUser,
        'shouldEmailAdmin': value.shouldEmailAdmin,
        'shouldSendNotificationWeb': value.shouldSendNotificationWeb,
        'shouldSendNotificationDevourPlay': value.shouldSendNotificationDevourPlay,
        'amount': value.amount,
        'amountUnit': AmountUnitToJSON(value.amountUnit),
        'durationAmount': value.durationAmount,
        'durationUnit': DurationUnitToJSON(value.durationUnit),
        'assetId': value.assetId,
        'nftTrackerId': value.nftTrackerId,
        'orderDiscountId': value.orderDiscountId,
        'promoTokenId': value.promoTokenId,
        'questConfigId': value.questConfigId,
        'emailTemplate': EmailTemplateToJSON(value.emailTemplate),
        'claimFormUrl': value.claimFormUrl,
        'maxClaimCount': value.maxClaimCount,
        'disclaimer': value.disclaimer,
    };
}


